<template>
  <div>

    <!-- SIDE BAR SECTION -->
  <div class="fixed z-50">
      <sideBar/>
    </div>


  <nav class="sticky w-full z-40 top-0 " >

        <navBar/>

  </nav>


    <!-- DASHBOARD -->

    <div class="bg-[#e8e6fe] w-full pb-12 font-euclid">

       

        <!-- ACCOUNT PAGE CONTENT -->

        <div class=" mx-10 ml-72 font-euclid  ">

            <div v-if="isClientMainAdmin">
                <div class=" flex justify-between items-center w-5/6 mb-6">

                    <h1 class=" mt-8 text-black font-semibold text-base mr-52">Associated Account(s)</h1>

                    <div>
                        <button
                        :disabled="!clientRecord.is_verified"
                        :class="!clientRecord.is_verified ? 'cursor-not-allowed' : ''"
                         @click="toggleAddAccountModal"  class=" mt-8 py-2 px-4 text-base text-medalertBlue disabled:bg-gray-200  font-semibold border-2 rounded-lg hover:bg-blueHover hover:text-white "> + New Account</button>
                    </div>

                </div>


                <div class="bg-white w-5/6 px-8 py-8 my-6 mb-4 rounded-md text-left">
                    <div v-for="(account,index) in AllClientAccount" :key="index">
                       <div>
                        <h1 class="text-medalertBlue my-3 cursor-pointer">{{(account.first_name).toUpperCase()}} {{(account.last_name).toUpperCase()}} - {{account.email}}
                        </h1>
                       </div>
                    </div>
                </div>
            </div>


            <div class=" flex justify-between items-center">

                <h1 class=" mt-8 text-black font-semibold text-base mr-52">Account Information</h1>

            </div>


            <div class="bg-white w-5/6 px-8 py-8 my-6 mb-4 rounded-md">
                <h1 class=" text-gray-500 font-medium text-sm text-left mr-52">COMPANY DETAILS</h1>

                <div class="grid w-full mt-10 text-black">

                    <div class="flex items-center">
                        <div class="text-left w-64">
                            <h1>Name</h1>
                        </div>
                        <div class="bg-gray-200 w-2/3 p-3 text-left rounded-md">
                            <h1 class="font-medium text-gray-600">{{clientRecord.name}}</h1>
                        </div>
                    </div>

                    <div class="flex items-center mt-8">
                        <div class="text-left w-64">
                            <h1>Verification</h1>
                        </div>
                        <div class="bg-gray-200 w-2/3 p-3 text-left rounded-md">
                            <h1 v-if="!clientRecord.is_verified" class="font-medium text-red">Unverified</h1>
                            <h1 v-if="clientRecord.is_verified" class="font-medium text-medalertBlue">Verified</h1>
                        </div>
                    </div>


                    <div class="flex items-center mt-8">
                        <div class="text-left w-64">
                            <h1>Type</h1>
                        </div>
                        <div class="bg-gray-200 w-2/3 p-3 text-left rounded-md">
                            <h1 class="font-medium text-gray-600">{{clientRecord.type}}</h1>
                        </div>
                    </div>

                    <div class="flex items-center mt-8">
                        <div class="text-left w-64">
                            <h1>Company Reg No</h1>
                        </div>
                        <div class="bg-gray-200 w-2/3 p-3 text-left rounded-md">
                            <h1 class="font-medium text-gray-600">{{clientRecord.cac_registration_number}}</h1>
                        </div>
                    </div>

                    <div class="flex items-center mt-8">
                        <div class="text-left w-64">
                            <h1>Street</h1>
                        </div>
                        <div class=" w-2/3  text-left rounded-md border-2">
                            <input v-model="updateStreet" class="font-medium text-black w-full p-3">
                        </div>
                    </div>

                    <div class="flex items-center mt-8">
                        <div class="text-left w-64">
                            <h1>Full Address</h1>
                        </div>

                        <div class=" w-2/3 text-left  flex justify-between">
                            <div class="flex flex-col w-3/12">
                                <h1 class="mb-2">City</h1>
                                <div class="bg-gray-200 rounded-md  text-left border-2 ">
                                    <input v-model="updateCity" class="font-medium text-gray-600 w-full p-3 ">
                                </div>
                            </div>

                            <div class="flex flex-col w-3/12">
                                <h1 class="mb-2">State</h1>
                                <div class="bg-gray-200 rounded-md   text-left  border-2">
                                    <select v-model="updateState"  class="font-medium w-full  p-3">
                                        <option value="Abuja(FCT)">Abuja(FCT)</option>
                                        <option value="Adamawa">Adamawa</option>
                                        <option value="Akwa Ibom">Akwa Ibom</option>
                                        <option value="Anambra">Anambra</option>
                                        <option value="Bauchi">Bauchi</option>
                                        <option value="Abia">Abia</option>
                                        <option value="Bayelsa">Bayelsa</option>
                                        <option value="Benue">Benue</option>
                                        <option value="Borno">Borno</option>
                                        <option value="Cross River">Cross River</option>
                                        <option value="Delta">Delta</option>
                                        <option value="Ebonyi">Ebonyi</option>
                                        <option value="Edo">Edo</option>
                                        <option value="Ekiti">Ekiti</option>
                                        <option value="Enugu">Enugu</option>
                                        <option value="Gombe">Gombe</option>
                                        <option value="Imo">Imo</option>
                                        <option value="Jigawa">Jigawa</option>
                                        <option value="Kaduna">Kaduna</option>
                                        <option value="Kano">Kano</option>
                                        <option value="Katsina">Katsina</option>
                                        <option value="Kebbi">Kebbi</option>
                                        <option value="Kogi">Kogi</option>
                                        <option value="Kwara">Kwara</option>
                                        <option value="Lagos">Lagos</option>
                                        <option value="Nasarawa">Nasarawa</option>
                                        <option value="Niger">Niger</option>
                                        <option value="Ogun">Ogun</option>
                                        <option value="Ondo">Ondo</option>
                                        <option value="Osun">Osun</option>
                                        <option value="Oyo">Oyo</option>
                                        <option value="Plateau">Plateau</option>
                                        <option value="Rivers">Rivers</option>
                                        <option value="Sokoto">Sokoto</option>
                                        <option value="Taraba">Taraba</option>
                                        <option value="Yobe">Yobe</option>
                                        <option value="Zamfara">Zamfara</option>
                                    </select>
                                </div>
                            </div>

                            <div class="flex flex-col w-3/12">
                                <h1 class="mb-2">Country</h1>
                                <div class="bg-gray-200 rounded-md   text-left  border-2 ">
                                    <select v-model="updateCountry"  class="font-medium w-full  p-3">
                                        <option value="Nigeria">Nigeria</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        
                    </div>

                   

                </div>

                <div class="text-black border-b-2 mt-16"></div>

                <h1 class=" text-gray-500 font-medium text-sm text-left mr-52 mb-8 mt-8">STAFF DETAILS</h1>


                <div class="flex items-center mt-8">
                        <div class="text-left w-64">
                            <h1>Full Name</h1>
                        </div>

                        <div class=" w-2/3 text-left  flex justify-between">
                            <div class="flex flex-col w-5/12">
                                <h1 class="mb-2">First Name</h1>
                                <div class="bg-gray-200 text-left rounded-md border-2 ">
                                    <input v-model="updateFirstName" class="text-black w-full p-3"  type="text">
                                </div>
                            </div>

                            <div class="flex flex-col w-5/12">
                                <h1 class="mb-2">Last Name</h1>
                                <div class="bg-gray-200 text-left rounded-md border-2 ">
                                    <input v-model="updateLastName" class="text-black w-full p-3" type="text">
                                </div>
                            </div>
                            
                        </div>
                        
                </div>

                <div class="flex items-center mt-8">
                        <div class="text-left w-64">
                            <h1>Contact Details</h1>
                        </div>

                        <div class=" w-2/3 text-left  flex justify-between">
                            <div class="flex flex-col w-5/12">
                                <h1 class="mb-2">Phone Number</h1>
                                <div class="bg-gray-200 text-left rounded-md border-2 ">
                                    <input v-model="updatePhoneNumber" class="text-black w-full p-3" type="number">
                                </div>
                            </div>

                            <div class="flex flex-col w-5/12">
                                <h1 class="mb-2">Email Address</h1>
                                <div class="bg-gray-200 text-left rounded-md border-2 ">
                                    <input v-model="updateEmail" class="text-black w-full p-3" type="email">
                                </div>
                            </div>
                            
                        </div>
                        
                </div>

                <div class="mt-20 flex justify-start mb-5">
                    <button disabled="true" class="py-3 px-4 disabled:bg-gray-200 text-white rounded-md">
                        Save Changes
                    </button>
                </div>

            </div>

<!-- 
            <h1 class=" mt-12 text-black font-semibold text-base mr-52 flex justify-start">Associated Account(s)
                
            </h1> -->


            
            
        </div>


         <!-- Add New Account Modal -->

        <div class="overflow-auto" v-show="addAccountModal " >
            <Modal :modalActive="addAccountModal" class="relative" @close="toggleAddAccountModal">
                <div class="close-icon absolute sm:top-15 lg:top-5 right-5 w-8 h-8 cursor-pointer hover:border-gray">
                    <svg
                    @click="toggleAddAccountModal"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 40 40"
                    enable-background="new 0 0 40 40"
                    >
                    <line
                        x1="15"
                        y1="15"
                        x2="25"
                        y2="25"
                        stroke="blue"
                        stroke-width="2.5"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                    />
                    <line
                        x1="25"
                        y1="15"
                        x2="15"
                        y2="25"
                        stroke="blue"
                        stroke-width="2.5"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                    />
                    <circle
                        class="circle"
                        cx="20"
                        cy="20"
                        r="19"
                        opacity="0"
                        stroke="blue"
                        stroke-width="2.5"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        fill="none"
                    />
                    <path
                        d="M20 1c10.45 0 19 8.55 19 19s-8.55 19-19 19-19-8.55-19-19 8.55-19 19-19z"
                        class="progress"
                        stroke="blue"
                        stroke-width="2.5"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        fill="none"
                    />
                    </svg>
                </div>

                <div
                v-if="success"
                class=" border w-full  mx-auto bg-medalertBlue bg-opacity-10  text-black px-4 py-3 rounded relative"
                role="alert">

                    <!-- <strong class="font-bold mx-2">Thank you!</strong> -->
                    <span class="">{{ success }}</span>
                </div>

                <div
                v-if="err"
                class=" border w-full  mx-auto bg-red  text-white px-4 py-3 rounded relative"
                role="alert">

                    <!-- <strong class="font-bold mx-2">Thank you!</strong> -->
                    <span class="">{{ err }}</span>
                </div>

                <h1 v-else class="border-b-2 text-left border-gray-light px-2 md:px-5 text-lg pb-1">Add New Account</h1>

                <div class="mx-auto bg-[#f1f3f8] pt-4"> 

                    <form @submit.prevent="handleAddNewAccount" action="" class="px-6">

                        <h1 class=" text-left border-gray-light text-base pb-2 font-semibold">STAFF DETAILS</h1>

                        <div class="flex mt-2 flex-col text-sm font-semibold">
                                <div class=" w-full text-left  flex justify-between">
                                    <div class="flex flex-col w-5/12">
                                        <h1 class="mb-2">First Name</h1>
                                        <div class="bg-gray-200 text-left rounded-md border-2 ">
                                            <input v-model="first_name" class="text-black w-full p-1.5" required type="text">
                                        </div>
                                    </div>

                                    <div class="flex flex-col w-5/12">
                                        <h1 class="mb-2">Last Name</h1>
                                        <div class="bg-gray-200 text-left rounded-md border-2 ">
                                            <input v-model="last_name"  class="text-black w-full p-1.5" required type="text">
                                        </div>
                                    </div>
                                    
                                </div>

                                <div class=" w-full text-left  flex justify-between mt-4">
                                    <div class="flex flex-col w-5/12">
                                        <h1 class="mb-2">Email</h1>
                                        <div class="bg-gray-200 text-left rounded-md border-2 ">
                                            <input v-model="email"  class="text-black w-full p-1.5" required type="email">
                                        </div>
                                    </div>

                                    <div class="flex flex-col w-5/12">
                                        <h1 class="mb-2">Phone Number</h1>
                                        <div class="bg-gray-200 text-left rounded-md border-2 ">
                                            <input v-model="phone_number" class="text-black w-full p-1.5" required type="number">
                                        </div>
                                    </div>
                                    
                                </div>  
                                
                                <div class="flex flex-col text-left mt-4 w-5/12 ">
                                    <div class="flex justify-between">
                                        <h1 class="mb-2">Password</h1>
                                        <div class="cursor-pointer text-xs font-semibold font-euclid">
                                            <span  @click="showPassword = !showPassword">  <p v-if="showPassword"> HIDE </p> <p v-else>SHOW</p> </span>
                                        </div>
                                    </div>
                                    <div class="bg-gray-200 text-left rounded-md border-2 ">
                                        <input 
                                        v-bind:type="[showPassword ? 'text' : 'password']"
                                        v-model="password"  class="text-black p-1.5 w-full"  required>
                                    </div>
                                </div>

                        </div>
                        <h1 class=" text-left border-gray-light text-base pb-2 font-semibold mt-5">COMPANY DETAILS</h1>



                        <div class="flex-col text-sm font-semibold">
                            <div class=" w-full text-left  flex justify-between mt-2 ">
                                <div class="flex flex-col w-5/12">
                                    <h1 class="mb-2">Street</h1>
                                    <div class="bg-gray-200 text-left rounded-md border-2 ">
                                        <input v-model="street_address"  class="text-black w-full p-1.5" required type="text">
                                    </div>
                                </div>

                                <div class="flex flex-col w-5/12">
                                    <h1 class="mb-2">City</h1>
                                    <div class="bg-gray-200 text-left rounded-md border-2 ">
                                        <input v-model="city"  class="text-black w-full p-1.5" required type="text">
                                    </div>
                                </div>
                                
                            </div>    

                            <div class=" w-full text-left  flex justify-between mt-4">
                                <div class="flex flex-col w-5/12">
                                    <h1 class="mb-2">State</h1>
                                    <div class="bg-gray-200 text-left rounded-md border-2 ">
                                        <select v-model="state" class="text-black w-full p-1.5" >
                                        <option value="Abuja(FCT)">Abuja(FCT)</option>
                                        <option value="Adamawa">Adamawa</option>
                                        <option value="Akwa Ibom">Akwa Ibom</option>
                                        <option value="Anambra">Anambra</option>
                                        <option value="Bauchi">Bauchi</option>
                                        <option value="Abia">Abia</option>
                                        <option value="Bayelsa">Bayelsa</option>
                                        <option value="Benue">Benue</option>
                                        <option value="Borno">Borno</option>
                                        <option value="Cross River">Cross River</option>
                                        <option value="Delta">Delta</option>
                                        <option value="Ebonyi">Ebonyi</option>
                                        <option value="Edo">Edo</option>
                                        <option value="Ekiti">Ekiti</option>
                                        <option value="Enugu">Enugu</option>
                                        <option value="Gombe">Gombe</option>
                                        <option value="Imo">Imo</option>
                                        <option value="Jigawa">Jigawa</option>
                                        <option value="Kaduna">Kaduna</option>
                                        <option value="Kano">Kano</option>
                                        <option value="Katsina">Katsina</option>
                                        <option value="Kebbi">Kebbi</option>
                                        <option value="Kogi">Kogi</option>
                                        <option value="Kwara">Kwara</option>
                                        <option value="Lagos">Lagos</option>
                                        <option value="Nasarawa">Nasarawa</option>
                                        <option value="Niger">Niger</option>
                                        <option value="Ogun">Ogun</option>
                                        <option value="Ondo">Ondo</option>
                                        <option value="Osun">Osun</option>
                                        <option value="Oyo">Oyo</option>
                                        <option value="Plateau">Plateau</option>
                                        <option value="Rivers">Rivers</option>
                                        <option value="Sokoto">Sokoto</option>
                                        <option value="Taraba">Taraba</option>
                                        <option value="Yobe">Yobe</option>
                                        <option value="Zamfara">Zamfara</option>
                                    </select>
                                    </div>
                                </div>

                                <div class="flex flex-col w-5/12">
                                    <h1 class="mb-2">Country</h1>
                                    <div class="bg-gray-200 text-left rounded-md border-2 ">
                                        <select v-model="country"  class="text-black w-full p-1.5">
                                            <option selected value="Nigeria">Nigeria</option>
                                         </select>
                                    </div>
                                </div>
                                
                            </div>  

                            <div class="mt-6 flex justify-start">
                                <button  class="py-2 px-5 bg-medalertBlue text-white rounded-md hover:bg-blueHover">
                                    <span v-if="!isLoading"> Add Account</span>
                                    <span class="px-4" v-if="isLoading">
                                        <Loading />
                                    </span>
                                </button>
                            </div>

                        </div>  

                    </form>

                </div>

            </Modal>
         </div>
        
       

       
    </div>

  </div>
</template>

<script>

import navBar from '../components/NavBar'
import sideBar from '../components/SideBar'
import axios from 'axios';
import Loading from "../components/Loading";


import { ref } from 'vue'
import {useRouter} from 'vue-router'
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import Modal from "../components/Modal.vue";

export default {

    components:{
    navBar,
    sideBar,
    Loading,
    Modal,
},


    setup(){

        const store = useStore();
        const route = useRoute();
        const router = useRouter();

        const success = ref('');
        const err = ref('');
        const isLoading = ref('');

        const showPassword = ref(false);


        const first_name = ref('');
        const last_name = ref('');
        const phone_number = ref('');
        const email = ref('');
        const password = ref('');
        const street_address = ref('');
        const city = ref('');
        const state = ref('');
        const country = ref('');

        const isClientMainAdmin = ref(true)


        const updateFirstName = ref('')
        const updateLastName = ref('')
        const updatePhoneNumber = ref('')
        const updateStreet= ref('')
        const updateCity= ref('')
        const updateState= ref('')
        const updateCountry= ref('')
        const updateEmail= ref('')
        const clientRecord = ref({})


        const addAccountModal = ref(false);

        const AllClientAccount = ref([])

        
        const accountDetails = async () =>{
        try{
            const clientInfo = await axios.get('/api/v1/account/me')
            if(clientInfo){
              const clientDetails =  clientInfo.data.data
              console.log(clientDetails)

              updateFirstName.value = clientDetails.first_name
              updateLastName.value = clientDetails.last_name
              updatePhoneNumber.value = clientDetails.phone_number
              updateEmail.value = clientDetails.email
              updateStreet.value = clientDetails.address.street_address
              updateCity.value = clientDetails.address.city
              updateState.value = clientDetails.address.state
              updateCountry.value = clientDetails.address.country

              clientRecord.value = clientDetails.client
              console.log(clientRecord)
            } else {
                throw new Error('could not retrive client account details')
            }

        } catch(error){
            console.log(error)
        }
        }


        const handleAddNewAccount = async () =>{
            try{
                isLoading.value = true;
                await store.dispatch('createMoreAccount', {
                    first_name: first_name.value,
                    last_name: last_name.value,
                    phone_number: phone_number.value,
                    email: email.value,
                    password: password.value,
                    address: {
                        street_address: street_address.value,
                        city: city.value,
                        state: state.value,
                        country: country.value
                    }
                });

                (first_name.value = "",
                last_name.value = "",
                phone_number.value = "",
                email.value = "",
                password.value = "",
                street_address.value = "",
                city.value = "",
                state.value = "",
                country.value = "")

                success.value = "New Account Created Successfully";
                
                

                setTimeout(() => {
                success.value = "";
                addAccountModal.value = false;
                router.push('/account')
                }, 3000);
                isLoading.value = false;

                getAllClientAccount()

               
            }

            catch(error){
                isLoading.value = false;
                err.value = error
                setTimeout(() => {
                err.value = null;
                 }, 3000);
            }
        };


        const toggleAddAccountModal = () => {
            addAccountModal.value = !addAccountModal.value;
        };


        const getAllClientAccount = async () => {
            try{
              const response = await axios.get('/api/v1/accounts/client?page-number=1&limit=50')
               console.log(response)
               AllClientAccount.value = response.data.data

            } 
            catch(error){
                console.log
            }
        }

        const getUserRole = async () =>{
            const userRole = store.state.user.role
            console.log(userRole)
            if(userRole != 'CLIENT_MAIN_ADMIN'){
                isClientMainAdmin.value = false
                console.log(isClientMainAdmin.value )
            }
        }


        return{
            accountDetails,
            toggleAddAccountModal,
            handleAddNewAccount,
            getAllClientAccount,
            getUserRole,
            showPassword,
            addAccountModal,
            updatePhoneNumber,
            updateLastName,
            updateFirstName,
            clientRecord,
            updateStreet,
            updateEmail,
            updateCity,
            updateState,
            updateCountry,
            first_name,
            last_name,
            phone_number,
            email,
            password,
            street_address,
            city,
            state,
            country,
            err,
            success,
            isLoading,
            AllClientAccount,
            isClientMainAdmin
        }

    },

    mounted(){
        this.accountDetails();
        this.getAllClientAccount();
        this.getUserRole();
    }

}
</script>

<style>

</style>